/// Webpack Imports
import { Modal } from 'bootstrap';

var $ = jQuery.noConflict();

// Ajoute la classe fixed-header
$(document).on('scroll', function() {
	var scroll = $(window).scrollTop();

	if (scroll >= 20) {
		$("header").addClass("fixed-header");
	} else {
		$("header").removeClass("fixed-header");
	}
});

// Hover sur le dropdown menu (Navigation principale)
$( document ).ready(function() {

    let dropdown_hover = $(".menu-item-has-children");
    dropdown_hover.on('mouseover', function(){
        let menu = $(this).find('.dropdown-menu'), toggle = $(this).find('.dropdown-toggle');
        menu.addClass('show');
        toggle.addClass('show').attr('aria-expanded', true);
    });
    dropdown_hover.on('mouseout', function(){
        let menu = $(this).find('.dropdown-menu'), toggle = $(this).find('.dropdown-toggle');
        menu.removeClass('show');
        toggle.removeClass('show').attr('aria-expanded', false);
    });
});

// Modale du moteur de recherche
var modaleRecherche = new Modal(document.getElementById('surfriderRecherche'));
$('.search-toggler').on('click', function() {
	modaleRecherche.show();
});
$('.search-close').on('click', function() {
	modaleRecherche.hide();
})

// Modale des push Donation
var modaleDonation = new Modal(document.getElementById('surfriderDonation'));
$('#btnDonation').on('click', function() {
	modaleDonation.show();
});
$('.close').on('click', function() {
	modaleDonation.hide();
})

// Apparition des sections en fade in
const sections = gsap.utils.toArray('section');

gsap.set(sections, {autoAlpha: 0, y: 0});

sections.forEach((section, i) => {
const anim = gsap.to(section, {duration: 1.2, autoAlpha: 1, y: 0, paused: true});

	ScrollTrigger.create({
		trigger: section,
		end: "bottom bottom",
		once: true,
		onEnter: self => {
			self.progress === 1 ? anim.progress(1) : anim.play()
		}
	});
});

$(document).on('ready', function() {
	$('.page-template-site-search .result-btn a').addClass('btnBlack');
	$('#gform_submit_button_2').addClass('btnBlue');
	$('#gform_submit_button_3').addClass('btnBlue');
});